
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remote-jobs",
      function () {
        return require("private-next-pages/remote-jobs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/remote-jobs"])
      });
    }
  